import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  Screen1,
  ProblemsWithVideo,
  Results,
  ResultsAndReviewsTop,
  Tasks,
  HowWorks,
  BlocksCourseStructure,
  AboutPeople,
  AboutAdvance,
  Founder,
  Cost,
  main
} from "../../../components/LandingTemplates/uchis_uchitsya";

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { VideoReviewsSimple } from "../../../components/VideoReviewsSimple";
import { FooterMedium } from "../../../components/FooterMedium";

import { blocksDataTeens } from "../../../components/LandingTemplates/uchis_uchitsya/data/blocksDataTeens";
import resultsAndReviewsTeens from "../../../components/LandingTemplates/uchis_uchitsya/data/resultsAndReviewsTeens.json";
import methodistsData from "../../../components/LandingTemplates/uchis_uchitsya/data/methodistsDataNew.json";
import videoReviews from "../../../components/LandingTemplates/uchis_uchitsya/data/videoReviewsSimpleTeens.json";

const TITLE = 'Курс «Учись учиться 8-11 класс»';
const DESCRIPTION = 'Научим учиться легко и с удовольствием, поднимем мотивацию, любознательность и уверенность в своих силах';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 targetGroup={"teens"} />
      <ProblemsWithVideo targetGroup={"teens"} />
      <Results/>
      <ResultsAndReviewsTop data={resultsAndReviewsTeens}/>
      <Tasks targetGroup={"teens"}/>
      <HowWorks
        targetGroup={"teens"}
        accessTimeText={"Доступ к нашей обучающей платформе на 2 года:"}
      />
      <BlocksCourseStructure
        data={blocksDataTeens}
        buttonText={"Оставить заявку"}
        buttonClassName={main.mainBtn}
        buttonAction={"anchor"}
      />
      <AboutPeople
        data={methodistsData}
        sectionClassName={main.methodists}
        title={"Над курсом работали:"}
        titleClassName={main.title2}
        bottomText={[<b>И ещё более 90 специалистов разного профиля:</b>, " методистов, педагогов, разработчиков," +
        " специалистов по мультимедиа продакшену, дизайнеров, сценаристов."]}
        bottomTextClassName={main.methodists__bottomText}
      />
      <AboutAdvance/>
      <Founder/>
      <Cost
        title={"Сколько стоит курс «Учись учиться 8–11 класс»"}
        widgetOtlichnik={<GetCourseWidget hash={'12bba5e93e40a6ae499472057fc874db091aeb54'} id={'690864'} />}
        widgetIndi={<GetCourseWidget hash={'20ad9165a49299c1f65cbf98f1ae1c1884c41715'} id={'690867'} />}
      />
      <VideoReviewsSimple
        data={videoReviews}
        sectionClassName={main.videoReviews__bottom}
        titleClassName={main.title2}
      />
    </main>

    <FooterMedium />
  </DefaultLayout>
);

export default Page;
